<script lang="ts" setup>
const localePath = useLocalePath()
definePageMeta({
  layout: 'auth'
})

const {t} = useI18n({
  useScope: 'global'
})

const submitHandler = async (formData, node) => {
  const client = useClient()
  try {
     const result = await client.auth.register.mutate(formData)
  } catch (e) {
    node.setErrors(
      [e.message],
    )
    return false;
  }
}
</script>

<template>
  <div>
    <FormKit
      id="registration"
      v-slot="{ value, disabled }"
      type="form"
      :actions="false"
      @submit="submitHandler"
    >
      <h2 class="form-title">
        {{ t('auth.register.title') }}
      </h2>
      <FormKit
        type="text"
        name="username"
        :placeholder="t('common.labels.username')"
        validation="required"
      />

      <div class="double">
        <FormKit
          type="password"
          name="password"
          :placeholder="t('common.labels.password')"
          validation="required|length:6|matches:/[^a-zA-Z]/"
          :validation-messages="{
            matches: 'Please include at least one symbol',
          }"
        />

        <FormKit
          type="password"
          name="password_confirm"
          :placeholder="t('common.labels.password_confirm')"
          validation="required|confirm"
        />

        <div class="form-nav">
          <div class="link">
            <NuxtLink :to="localePath('/auth/login')">
              {{ t('auth.register.alreadyHaveAccount') }}
            </NuxtLink>
          </div>
        </div>

        <FormKit
          type="submit"
          width="full"
          :label="t('auth.register.submit')"
        />
      </div>
    </FormKit>
  </div>
</template>

<style scoped lang="scss">

.form-title {
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  margin-bottom: 30px;
}

.form-item {
  width: 100%;
  margin-bottom: 25px;
}

.submit {
  width: 100%;
}

.form-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin: 5px 0 30px;

  .link {
    font-size: 12px;
  }
}

.btn {
  width: 100%;
}

</style>

<i18n lang="json">

{
  "ru": {
    "register": "Register"
  },
  "en": {
    "register": "Зарегистрироваться"
  }
}
</i18n>
